import React from "react";
import { Link } from "react-router-dom";
import heroSectionImage from "../../../assets/service-hero-image.jpg";
import { Dots } from "react-dot-patterns";

const HeroSection = () => {
  return (
    <div className="on-service-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>
              Holistic,&nbsp;
              <br />
              <span>Human-Centered</span>
              <br />
              Design
            </h1>
            <p>
              Build, scale, and optimize your connected ecosystem with
              human-centered Iot product design - and deliver material outcomes
              from Day 1.
            </p>
            <Link to="/services">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
